import { MediaQuery } from '@maxpreps/shared/styles/breakpoint';
import THEME, { COLOR } from '@maxpreps/shared/styles/colors';
import styled from 'styled-components';

export const NavBarWrapper = styled.div`
  position: relative;
  background-color: ${COLOR.white};

  .stuck & {
    box-shadow: 0 8px 8px 0 ${THEME.shadow.light};
  }
`;

export const NavBarContainer = styled.nav`
  height: 44px;
  max-width: 1440px;

  margin-left: 8px;
  ${MediaQuery.Tablet} {
    margin-left: 16px;
    height: 52px;
  }

  display: grid;
  grid-template-columns: min-content auto;
  white-space: nowrap;

  overflow-x: auto;
  overflow-y: visible;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const NavBarLinkList = styled.ul`
  display: flex;
  height: 100%;

  & > li {
    height: 100%;
    margin: 0 8px;
  }
  & > li > div {
    height: 100%;
    display: flex;
    flex-flow: column;
    flex-wrap: nowrap;
  }
  & > li > div > div:first-child {
    flex: 1 1 100%;
  }

  & .link {
    height: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    color: ${({ theme }) => theme.colors.text.secondary};
  }
  & .link > svg {
    margin-left: 2px;
  }

  & > li.active .link,
  & > li:hover .link {
    color: ${THEME.text.primary};
  }

  & > li.active .link {
    font-weight: 700;
  }

  & > li:hover .link {
    color: ${({ theme }) => theme.colors.other.link};
  }

  & > li .link::after {
    content: '';
    position: absolute;
    bottom: 0;
    height: 4px;
    width: 100%;
    border-radius: 4px 4px 0 0;
  }
  & > li.active .link::after {
    background-color: ${({ theme }) => theme.colors.other.link};
  }
`;

export const StyledLeftContentContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  border-right: 1px solid ${THEME.general.border};

  padding-right: 16px;
  margin-right: 16px;
`;
